import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Switch,
  Textarea,
  Button,
  useToast,
  VStack,
  HStack,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
} from '@chakra-ui/react';
import { useAuth } from '../../context/AuthContext';

const AdminEmail = () => {
  const { t } = useTranslation();
  const { accessToken: token } = useAuth(); // Renombrar accessToken a token para mantener compatibilidad
  const toast = useToast();
  const [logs, setLogs] = useState('');
  const [isLoadingLogs, setIsLoadingLogs] = useState(false);
  const [sortBy, setSortBy] = useState('descripcion');
  const [sortOrder, setSortOrder] = useState('asc');
  const [endpointsOriginal] = useState([
    { 
      descripcion: 'Bienvenida al cliente',
      endpoint: '/api/email/bienvenida-cliente',
      habilitado: true,
      subject: '[www.overtaxi.es] 🎉 ¡Bienvenido/a a Overtaxi!',
      destinatario: 'Cliente'
    },
    { 
      descripcion: 'Notificación nuevo cliente (admin)',
      endpoint: '/api/email/notificacion-nuevo-cliente',
      habilitado: true,
      subject: '[www.overtaxi.es] 👤 Nuevo cliente registrado en Overtaxi',
      destinatario: 'Administrador'
    },
    { 
      descripcion: 'Verificación de cuenta',
      endpoint: '/api/email/verificacion-cuenta',
      habilitado: true,
      subject: '[www.overtaxi.es] 🔐 Verifica tu correo electrónico',
      destinatario: 'Cliente'
    },
    { 
      descripcion: 'Nueva reserva (admin)',
      endpoint: '/api/email/nueva-reserva-admin',
      habilitado: true,
      subject: '[www.overtaxi.es] 🚖 Nueva Reserva #[ID] - [Método Pago]',
      destinatario: 'Administrador'
    },
    { 
      descripcion: 'Confirmación reserva (cliente)',
      endpoint: '/api/email/confirmacion-cliente',
      habilitado: true,
      subject: '[www.overtaxi.es] ✅ Confirmación de Reserva #[ID]',
      destinatario: 'Cliente'
    },
    { 
      descripcion: 'Cancelación reserva (cliente)',
      endpoint: '/api/email/cancelacion-cliente',
      habilitado: true,
      subject: '[www.overtaxi.es] ❌ Cancelación de Reserva #[ID]',
      destinatario: 'Cliente'
    },
    { 
      descripcion: 'Cancelación reserva (conductor)',
      endpoint: '/api/email/cancelacion-conductor',
      habilitado: true,
      subject: '[www.overtaxi.es] 🚫 Cancelación de Reserva Asignada #[ID]',
      destinatario: 'Conductor'
    },
    { 
      descripcion: 'Abandono conductor',
      endpoint: '/api/email/abandono-conductor',
      habilitado: true,
      subject: '[www.overtaxi.es] 🏃 Confirmación de Abandono de Servicio - Reserva #[ID]',
      destinatario: 'Conductor'
    },
    { 
      descripcion: 'Abandono admin',
      endpoint: '/api/email/abandono-admin',
      habilitado: true,
      subject: '[www.overtaxi.es] ⚠️ Conductor Abandonó Servicio - Reserva #[ID]',
      destinatario: 'Administrador'
    },
    { 
      descripcion: 'Invitación conductor',
      endpoint: '/api/email/invitacion-conductor',
      habilitado: true,
      subject: '[www.overtaxi.es] 🚕 Invitación a Servicio - Overtaxi #[ID]',
      destinatario: 'Conductor'
    },
    { 
      descripcion: 'Invitación admin',
      endpoint: '/api/email/invitacion-admin',
      habilitado: true,
      subject: '[www.overtaxi.es] 📧 Invitación a Conductor - Servicio #[ID]',
      destinatario: 'Administrador'
    },
    { 
      descripcion: 'Transferencia conductor',
      endpoint: '/api/email/transferencia-conductor',
      habilitado: true,
      subject: '[www.overtaxi.es] 🔄 Servicio Transferido - Overtaxi #[ID]',
      destinatario: 'Conductor'
    },
    { 
      descripcion: 'Transferencia admin',
      endpoint: '/api/email/transferencia-admin',
      habilitado: true,
      subject: '[www.overtaxi.es] 🔀 Transferencia de Servicio - #[ID]',
      destinatario: 'Administrador'
    },
    { 
      descripcion: 'Aviso de servicios sin cubrir',
      endpoint: '/api/email/aviso-servicios-sin-cubrir',
      habilitado: true,
      subject: '[www.overtaxi.es] 🔔 Servicio sin cubrir - #[ID]',
      destinatario: 'Socios activos'
    },
    { 
      descripcion: 'Periodo de cancelación expirado',
      endpoint: '/api/email/periodo-cancelacion-expirado',
      habilitado: true,
      subject: '[www.overtaxi.es] ⏰ Periodo de cancelación expirado - #[ID]',
      destinatario: 'Administrador'
    },
    { 
      descripcion: 'Recordatorio inicio servicio',
      endpoint: '/api/email/recordatorio-inicio-servicio',
      habilitado: true,
      subject: '[www.overtaxi.es] 🕐 Recordatorio de servicio - #[ID]',
      destinatario: 'Cliente y Conductor'
    },
    { 
      descripcion: 'Recordatorio devolución servicio',
      endpoint: '/api/email/recordatorio-devolucion',
      habilitado: true,
      subject: '[www.overtaxi.es] 🔙 Recordatorio de devolución - #[ID]',
      destinatario: 'Administrador'
    },
    { 
      descripcion: 'Reserva no cubierta',
      endpoint: '/api/email/no-podemos-atender-su-reserva',
      habilitado: true,
      subject: '[www.overtaxi.es] 🚷 No pudimos cubrir su reserva - #[ID]',
      destinatario: 'Cliente'
    },
    { 
      descripcion: 'Conductor asignado',
      endpoint: '/api/email/conductor-asignado',
      habilitado: true,
      subject: '[www.overtaxi.es] 👍 Conductor asignado a su reserva - #[ID]',
      destinatario: 'Cliente'
    },
    { 
      descripcion: 'Formulario de contacto',
      endpoint: '/api/email/contacto',
      habilitado: true,
      subject: '[www.overtaxi.es] Overtaxi.es - Formulario de contacto',
      destinatario: 'Administrador'
    },
    { 
      descripcion: 'Reporte de tarea programada',
      endpoint: '/api/email/reporte-tarea',
      habilitado: true,
      subject: '[Overtaxi Scheduler] 📊 Reporte: [Nombre Tarea]',
      destinatario: 'Administrador'
    },
  ]);
  const [emailEndpoints, setEmailEndpoints] = useState(endpointsOriginal);
  const [testingEndpoint, setTestingEndpoint] = useState(null);
  const [selectedLanguages, setSelectedLanguages] = useState(() => {
    // Inicializar con 'es' para cada endpoint
    const initialLanguages = {};
    endpointsOriginal.forEach(endpoint => {
      initialLanguages[endpoint.endpoint] = 'es';
    });
    return initialLanguages;
  });

  const getTestData = (endpoint, idioma = 'es') => {
    const adminEmail = 'temp@example.com';  // Email temporal, prueba redirigirá al ADMIN_EMAIL

    switch (endpoint) {
      case '/api/email/bienvenida-cliente':
        return { destinatario: adminEmail, nombre: 'Usuario Test', anexos: [], idioma, prueba: true };
      case '/api/email/notificacion-nuevo-cliente':
        return { cliente_id: '650e8400-e29b-41d4-a716-446655440000', email: 'test@example.com', nombre: 'Test', apellidos: 'Usuario', telefono: '+34600000000', fecha_creacion: new Date().toISOString(), idioma, prueba: true };
      case '/api/email/verificacion-cuenta':
        return { destinatario: adminEmail, codigo_verificacion: '123456', idioma, prueba: true };
      case '/api/email/nueva-reserva-admin':
        return { reserva_id: '650e8400-e29b-41d4-a716-446655440001', tipo: 'aeropuerto', origen_lat: 39.5696, origen_lng: 2.6462, destino_lat: 39.5516, destino_lng: 2.5990, distancia_km: 12.5, precio: 45.00, fecha_hora_inicio: new Date().toISOString(), estado: 'pendiente', sub_estado: 'esperando_confirmacion', cliente_nombre: 'Test', cliente_apellidos: 'Usuario', cliente_email: 'test@example.com', cliente_telefono: '+34600000000', metodo_pago: 'C', idioma, prueba: true };
      case '/api/email/confirmacion-cliente':
        return { reserva_id: '750e8400-e29b-41d4-a716-446655440002', tipo: 'programado', origen_lat: 39.5330, origen_lng: 2.5230, destino_lat: 39.5696, destino_lng: 2.6462, origen_direccion: 'Calle Mayor 1, Palma de Mallorca', destino_direccion: 'Avenida Alemania 45, El Arenal, Palma', distancia_km: 8.3, precio: 35.00, precio_reserva: 35.00, precio_maximo_adjudicacion: 3.50, fecha_hora_inicio: new Date().toISOString(), fecha_hora_fin: new Date(Date.now() + 30*60*1000).toISOString(), cliente_nombre: 'Test', cliente_apellidos: 'Usuario', cliente_email: adminEmail, metodo_pago: 'C', estado: 'confirmado', idioma, prueba: true };
      case '/api/email/cancelacion-cliente':
        return { reserva_id: '850e8400-e29b-41d4-a716-446655440003', tipo: 'programado', origen_lat: 38.9067, origen_lng: 1.4206, destino_lat: 38.8729, destino_lng: 1.3731, origen_direccion: 'Calle de San Juan 15, Ibiza', destino_direccion: 'Aeropuerto de Ibiza, Sant Jordi de ses Salines', distancia_km: 10.5, precio: 28.00, precio_reserva: 28.00, precio_maximo_adjudicacion: 2.80, fecha_hora_inicio: new Date().toISOString(), fecha_hora_fin: new Date(Date.now() + 25*60*1000).toISOString(), metodo_pago: 'C', estado: 'cancelado', cliente_email: adminEmail, motivo: 'Prueba de email de cancelación', idioma, prueba: true };
      case '/api/email/cancelacion-conductor':
        return { reserva_id: '950e8400-e29b-41d4-a716-446655440004', tipo: 'programado', conductor_nombre: 'Test', conductor_apellidos: 'Conductor', conductor_email: adminEmail, origen_lat: 39.5696, origen_lng: 2.6462, destino_lat: 39.5516, destino_lng: 2.5990, origen_direccion: 'Calle Jaume III 10, Palma', destino_direccion: 'Plaza España 1, Palma', distancia_km: 3.2, precio: 15.00, precio_reserva: 15.00, precio_maximo_adjudicacion: 1.50, fecha_hora_inicio: new Date().toISOString(), fecha_hora_fin: new Date(Date.now() + 15*60*1000).toISOString(), metodo_pago: 'C', estado: 'cancelado', motivo: 'Prueba de email de cancelación a conductor', idioma, prueba: true };
      case '/api/email/abandono-conductor':
        return { reserva_id: 'a50e8400-e29b-41d4-a716-446655440005', tipo: 'programado', conductor_nombre: 'Test', conductor_apellidos: 'Conductor', conductor_email: adminEmail, origen_lat: 39.5696, origen_lng: 2.6462, destino_lat: 39.5516, destino_lng: 2.5990, origen_direccion: 'Calle Jaume III 10, Palma', destino_direccion: 'Plaza España 1, Palma', distancia_km: 3.2, precio: 15.00, precio_reserva: 15.00, precio_maximo_adjudicacion: 1.50, fecha_hora_inicio: new Date().toISOString(), fecha_hora_fin: new Date(Date.now() + 15*60*1000).toISOString(), metodo_pago: 'C', idioma, prueba: true };
      case '/api/email/abandono-admin':
        return { reserva_id: 'b50e8400-e29b-41d4-a716-446655440006', tipo: 'programado', conductor_nombre: 'Test', conductor_apellidos: 'Conductor', conductor_email: 'test@example.com', origen_lat: 39.5696, origen_lng: 2.6462, destino_lat: 39.5516, destino_lng: 2.5990, origen_direccion: 'Calle Jaume III 10, Palma', destino_direccion: 'Plaza España 1, Palma', distancia_km: 3.2, precio: 15.00, precio_reserva: 15.00, precio_maximo_adjudicacion: 1.50, fecha_hora_inicio: new Date().toISOString(), fecha_hora_fin: new Date(Date.now() + 15*60*1000).toISOString(), metodo_pago: 'C', estado: 'abandonado', idioma, prueba: true };
      case '/api/email/invitacion-conductor':
        return { reserva_id: 'c50e8400-e29b-41d4-a716-446655440007', tipo: 'programado', email_invitado: adminEmail, conductor_invita_nombre: 'Test', conductor_invita_apellidos: 'Conductor', origen_lat: 39.5696, origen_lng: 2.6462, destino_lat: 39.5516, destino_lng: 2.5990, origen_direccion: 'Calle Son Armadans 25, Palma', destino_direccion: 'Aeropuerto de Palma, Palma', distancia_km: 8.5, precio: 45.00, precio_reserva: 45.00, precio_maximo_adjudicacion: 4.50, fecha_hora_inicio: new Date().toISOString(), fecha_hora_fin: new Date(Date.now() + 25*60*1000).toISOString(), metodo_pago: 'C', idioma, prueba: true };
      case '/api/email/invitacion-admin':
        return { reserva_id: 'd50e8400-e29b-41d4-a716-446655440008', tipo: 'programado', email_invitado: 'test@example.com', conductor_invita_nombre: 'Test', conductor_invita_apellidos: 'Conductor', origen_lat: 39.5696, origen_lng: 2.6462, destino_lat: 39.5516, destino_lng: 2.5990, origen_direccion: 'Calle Bellver 12, Palma', destino_direccion: 'Calle Archiduque Luis Salvador 50, Palma', distancia_km: 4.2, precio: 22.00, precio_reserva: 22.00, precio_maximo_adjudicacion: 2.20, fecha_hora_inicio: new Date().toISOString(), fecha_hora_fin: new Date(Date.now() + 20*60*1000).toISOString(), metodo_pago: 'C', estado: 'pendiente', idioma, prueba: true };
      case '/api/email/transferencia-conductor':
        return { reserva_id: 'e50e8400-e29b-41d4-a716-446655440009', tipo: 'programado', conductor_destinatario_nombre: 'Test2', conductor_destinatario_apellidos: 'Conductor2', conductor_destinatario_email: adminEmail, conductor_transfiere_nombre: 'Test', conductor_transfiere_apellidos: 'Conductor', origen_lat: 39.5696, origen_lng: 2.6462, destino_lat: 39.5516, destino_lng: 2.5990, origen_direccion: 'Calle Constitución 5, Palma', destino_direccion: 'Paseo Marítimo 18, Palma', distancia_km: 5.8, precio: 28.00, precio_reserva: 28.00, precio_maximo_adjudicacion: 2.80, fecha_hora_inicio: new Date().toISOString(), fecha_hora_fin: new Date(Date.now() + 18*60*1000).toISOString(), metodo_pago: 'C', estado: 'confirmada', sub_estado: 'pendiente_recogida', idioma, prueba: true };
      case '/api/email/transferencia-admin':
        return { reserva_id: 'f50e8400-e29b-41d4-a716-446655440010', tipo: 'programado', conductor_destinatario_nombre: 'Test2', conductor_destinatario_apellidos: 'Conductor2', conductor_destinatario_email: 'test2@example.com', conductor_transfiere_nombre: 'Test', conductor_transfiere_apellidos: 'Conductor', origen_lat: 39.5696, origen_lng: 2.6462, destino_lat: 39.5516, destino_lng: 2.5990, origen_direccion: 'Calle Sindicat 8, Palma', destino_direccion: 'Calle General Riera 15, Palma', distancia_km: 3.5, precio: 18.00, precio_reserva: 18.00, precio_maximo_adjudicacion: 1.80, fecha_hora_inicio: new Date().toISOString(), fecha_hora_fin: new Date(Date.now() + 12*60*1000).toISOString(), metodo_pago: 'C', estado: 'confirmada', idioma, prueba: true };
      case '/api/email/aviso-servicios-sin-cubrir':
        // ⚠️ Usa un conductor_id real de tu base de datos
        return { 
          reserva_id: '050e8400-e29b-41d4-a716-446655440011',
          conductor_id: 'e7124650-f952-429a-ad5d-ef98a92bb2d6', // ⚠️ Cambia por un ID real
          tipo: 'programado', 
          origen_lat: 39.5696, 
          origen_lng: 2.6462, 
          destino_lat: 39.5516, 
          destino_lng: 2.5990,
          origen_direccion: 'Calle de la Reina Victoria 7, Palma',
          destino_direccion: 'Calle Bartolomé Riutort 2, Palma',
          fecha_hora_inicio: new Date(Date.now() + 60*60*1000).toISOString(), // +1 hora
          fecha_hora_fin: new Date(Date.now() + 90*60*1000).toISOString(), // +1.5 horas
          distancia_km: 12.5, 
          precio: 45.00,
          precio_reserva: 45.00,
          precio_maximo_adjudicacion: 4.50,
          metodo_pago: 'C',
          estado: 'pendiente',
          tiempo_sin_cubrir: 240, 
          idioma, 
          prueba: true 
        };
      case '/api/email/reporte-tarea':
        // ⚠️ Usa un tarea_id real de tu base de datos
        return {
          tarea_id: 'dc9c97b3-5705-419a-ae42-49fa78cd490c', // ⚠️ Cambia por un ID real de una tarea
          idioma,
          prueba: true
        };
      case '/api/email/periodo-cancelacion-expirado':
        // ⚠️ Usa IDs reales de tu base de datos
        return { 
          reserva_id: '16e9dbb3-d1b1-4249-818c-080899d39375', // ⚠️ Cambia por un ID real
          cliente_id: 'bc8f0b05-403b-4ff0-9e67-7e7930b0e52e', // ⚠️ Cambia por un ID real
          idioma, 
          prueba: true 
        };
      case '/api/email/recordatorio-inicio-servicio':
        // ⚠️ Usa IDs reales de tu base de datos y proporciona cliente_id O conductor_id
        return { 
          reserva_id: '16e9dbb3-d1b1-4249-818c-080899d39375', // ID real usado en otras pruebas
          cliente_id: 'bc8f0b05-403b-4ff0-9e67-7e7930b0e52e', // ID real usado en otras pruebas
          // conductor_id: 'e7124650-f952-429a-ad5d-ef98a92bb2d6', // Alternativa: usa conductor_id en lugar de cliente_id
          idioma, 
          prueba: true 
        };
      case '/api/email/recordatorio-devolucion':
        return { 
          reserva_id: '16e9dbb3-d1b1-4249-818c-080899d39375',
          cliente_id: 'bc8f0b05-403b-4ff0-9e67-7e7930b0e52e',
          conductor_id: 'e7124650-f952-429a-ad5d-ef98a92bb2d6',
          minutos_retraso: 180, 
          idioma, 
          prueba: true 
        };
      case '/api/email/contacto':
        return { 
          email_usuario: 'test@example.com', 
          asunto_seleccionado: 'Prueba', 
          mensaje: 'Este es un mensaje de prueba', 
          ip_origen: '127.0.0.1',
          device_info: {
            user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/136.0.0.0 Safari/537.36 Edg/136.0.0.0',
            accept_language: 'es-ES,es;q=0.9,en;q=0.8',
            languages: 'es-ES, es, en',
            app_version: '5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/136.0.0.0 Safari/537.36 Edg/136.0.0.0',
            platform: 'Win32',
            vendor: 'Google Inc.',
            ip_address: '192.168.1.100',
            ip_address_forwarded: '203.0.113.45',
            origin: 'https://www.overtaxi.es',
            referer: 'https://www.overtaxi.es/contacto',
            connection_type: '4g',
            online: true,
            accept_encoding: 'gzip, deflate, br',
            x_requested_with: 'XMLHttpRequest',
            custom_device_id: 'device-123456789',
            screen_width: 1920,
            screen_height: 1080,
            screen_color_depth: 24,
            viewport_width: 1536,
            viewport_height: 864,
            timezone: 'Europe/Madrid',
            cookie_enabled: true,
            do_not_track: null,
            hardware_concurrency: 8,
            device_memory: 8,
            max_touch_points: 0,
            latitude: 39.5696,
            longitude: 2.6502,
            location_accuracy: 50,
            address: 'Palma, Balearic Islands, Spain'
          },
          usuario_autenticado: {
            id: 'bc8f0b05-403b-4ff0-9e67-7e7930b0e52e',
            nombre: 'Usuario Test',
            email: 'test@example.com',
            user_type: 'cliente'
          },
          idioma,
          prueba: true 
        };
      case '/api/email/no-podemos-atender-su-reserva':
        // ⚠️ Usa IDs reales de tu base de datos
        return { 
          reserva_id: '16e9dbb3-d1b1-4249-818c-080899d39375', // ⚠️ Cambia por un ID real
          cliente_id: 'bc8f0b05-403b-4ff0-9e67-7e7930b0e52e', // ⚠️ Cambia por un ID real
          idioma, 
          prueba: true 
        };
      case '/api/email/conductor-asignado':
        // ⚠️ Usa IDs reales de tu base de datos
        return { 
          reserva_id: '16e9dbb3-d1b1-4249-818c-080899d39375', // ⚠️ Cambia por un ID real
          cliente_id: 'bc8f0b05-403b-4ff0-9e67-7e7930b0e52e', // ⚠️ Cambia por un ID real
          conductor_id: 'e7124650-f952-429a-ad5d-ef98a92bb2d6', // ⚠️ Cambia por un ID real
          idioma, 
          prueba: true 
        };
      default:
        return {};
    }
  };

  const handleTestEmail = async (endpoint) => {
    setTestingEndpoint(endpoint);
    
    try {
      const testData = getTestData(endpoint, selectedLanguages[endpoint]);
      const serviceKey = process.env.REACT_APP_SERVICE_API_KEY_MANUAL || '';
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
      const fullUrl = `${apiBaseUrl}${endpoint}`;
      
      console.log('[EMAIL TEST] Enviando petición:', {
        endpoint,
        fullUrl,
        testData,
        idioma: selectedLanguages[endpoint],
        serviceKey: serviceKey ? '***presente***' : 'FALTA'
      });
      
      // Mostrar toast informativo antes de enviar
      toast({
        title: 'Enviando email de prueba',
        description: 'Preparando envío...',
        status: 'info',
        duration: 2000,
        isClosable: true,
      });

      const response = await fetch(fullUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Service-Key': serviceKey,
        },
        body: JSON.stringify(testData),
      });

      console.log('[EMAIL TEST] Respuesta recibida:', {
        status: response.status,
        statusText: response.statusText,
        headers: Object.fromEntries(response.headers.entries())
      });

      // Capturar el texto de respuesta primero
      const responseText = await response.text();
      console.log('[EMAIL TEST] Response text:', responseText);

      // Intentar parsear como JSON
      let data;
      try {
        data = JSON.parse(responseText);
        console.log('[EMAIL TEST] Response parsed:', data);
      } catch (parseError) {
        console.error('[EMAIL TEST] Error parsing JSON:', parseError);
        console.error('[EMAIL TEST] Raw response:', responseText);
        toast({
          title: 'Error de respuesta',
          description: `No se pudo parsear la respuesta del servidor. Ver consola para detalles.`,
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      if (response.ok && data.success) {
        console.log('[EMAIL TEST] Email enviado exitosamente');
        toast({
          title: 'Email enviado correctamente',
          description: `Email de prueba enviado a ${data.destinatario}`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        
        // Recargar logs después de enviar el email
        console.log('[EMAIL TEST] Recargando logs...');
        await fetchLogs();
      } else {
        console.error('[EMAIL TEST] Error en respuesta:', data);
        toast({
          title: 'Error al enviar email',
          description: data.message || data.error || 'Error desconocido',
          status: 'error',
          duration: 4000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('[EMAIL TEST] Exception capturada:', error);
      console.error('[EMAIL TEST] Stack trace:', error.stack);
      toast({
        title: 'Error',
        description: `${error.message} - Ver consola para más detalles`,
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setTestingEndpoint(null);
    }
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(column);
      setSortOrder('asc');
    }
  };

  useEffect(() => {
    if (sortBy) {
      const sorted = [...endpointsOriginal].sort((a, b) => {
        const valueA = a[sortBy];
        const valueB = b[sortBy];

        if (typeof valueA === 'string' && typeof valueB === 'string') {
          return sortOrder === 'asc'
            ? valueA.localeCompare(valueB)
            : valueB.localeCompare(valueA);
        } else if (typeof valueA === 'boolean' && typeof valueB === 'boolean') {
          return sortOrder === 'asc'
            ? (valueA === valueB ? 0 : (valueA ? 1 : -1))
            : (valueA === valueB ? 0 : (valueA ? -1 : 1));
        } else {
          const stringA = String(valueA);
          const stringB = String(valueB);
          return sortOrder === 'asc'
            ? stringA.localeCompare(stringB)
            : stringB.localeCompare(stringA);
        }
      });
      setEmailEndpoints(sorted);
    } else {
      setEmailEndpoints(endpointsOriginal);
    }
  }, [sortBy, sortOrder, endpointsOriginal]);

  const fetchLogs = useCallback(async () => {
    console.log('[FETCH LOGS] Iniciando fetchLogs, token:', token ? 'presente' : 'null');
    
    setIsLoadingLogs(true);
    try {
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
      const fullUrl = `${apiBaseUrl}/api/email/logs`;
      
      console.log('[FETCH LOGS] Obteniendo logs desde:', fullUrl);
      console.log('[FETCH LOGS] Token presente:', token ? 'SÍ' : 'NO');
      console.log('[FETCH LOGS] Token (primeros 20 chars):', token ? token.substring(0, 20) + '...' : 'null');
      
      const response = await fetch(fullUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        credentials: 'include',
      });
      
      console.log('[FETCH LOGS] Response status:', response.status);
      console.log('[FETCH LOGS] Response headers:', response.headers);

      // Si la respuesta es 404 o no OK, puede ser que no haya logs o el archivo no exista
      if (!response.ok) {
        if (response.status === 404) {
          setLogs('No hay logs disponibles');
          toast({
            title: 'Información',
            description: 'No se encontraron logs de email',
            status: 'info',
            duration: 2000,
            isClosable: true,
          });
          return;
        }
        throw new Error(`Error: ${response.status}`);
      }

      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        // Si no es JSON, probablemente está vacío o es HTML de error
        setLogs('No hay logs disponibles');
        toast({
          title: 'Información',
          description: 'No hay logs de email disponibles',
          status: 'info',
          duration: 2000,
          isClosable: true,
        });
        return;
      }

      const data = await response.json();
      
      console.log('[FETCH LOGS] Respuesta JSON:', data);
      console.log('[FETCH LOGS] Número de logs:', data.logs?.length);
      
      // Formatear los logs para mostrarlos
      if (data.success && data.logs && data.logs.length > 0) {
        const formattedLogs = data.logs
          .map(log => `[${log.timestamp || ''}] ${log.linea}`)
          .join('\n');
        console.log('[FETCH LOGS] Logs formateados, longitud:', formattedLogs.length);
        setLogs(formattedLogs);
      } else {
        setLogs('No hay logs disponibles');
        toast({
          title: 'Información',
          description: 'No hay logs de email registrados',
          status: 'info',
          duration: 2000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error al cargar logs:', error);
      setLogs('No hay logs disponibles');
      toast({
        title: 'Información',
        description: 'No se pudieron cargar los logs',
        status: 'info',
        duration: 2000,
        isClosable: true,
      });
    } finally {
      setIsLoadingLogs(false);
    }
  }, [token, toast]);

  const fetchEmailSettings = useCallback(async () => {
    try {
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
      const response = await fetch(`${apiBaseUrl}/api/settings`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const settings = await response.json();
        // Actualizar el estado de habilitado en los endpoints
        const updatedEndpoints = endpointsOriginal.map(endpoint => {
          const setting = settings.find(s => s.endpoint === endpoint.endpoint);
          return {
            ...endpoint,
            habilitado: setting ? setting.habilitado : endpoint.habilitado
          };
        });
        setEmailEndpoints(updatedEndpoints);
      }
    } catch (error) {
      console.error('Error al cargar configuraciones de email:', error);
    }
  }, [token, endpointsOriginal]);

  useEffect(() => {
    // Cargar configuraciones y logs si el token está disponible
    if (token) {
      fetchLogs();
      fetchEmailSettings();
    }
  }, [token, fetchLogs, fetchEmailSettings]);

  const handleToggle = async (index) => {
    const endpoint = emailEndpoints[index];
    const newHabilitado = !endpoint.habilitado;

    try {
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
      // Usar el endpoint completo tal como está (ej: /api/email/scheduler-healthcheck)
      const endpointPath = endpoint.endpoint;
      
      const response = await fetch(`${apiBaseUrl}/api/settings${endpointPath}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ habilitado: newHabilitado }),
      });

      if (response.ok) {
        // Actualizar el estado local
        const updatedEndpoints = [...emailEndpoints];
        updatedEndpoints[index] = { ...updatedEndpoints[index], habilitado: newHabilitado };
        setEmailEndpoints(updatedEndpoints);
        
        toast({
          title: 'Configuración actualizada',
          description: `Endpoint ${newHabilitado ? 'habilitado' : 'deshabilitado'} correctamente`,
          status: 'success',
          duration: 2000,
          isClosable: true,
        });
      } else {
        toast({
          title: 'Error',
          description: 'No se pudo actualizar la configuración',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error al actualizar configuración:', error);
      toast({
        title: 'Error',
        description: 'Error de conexión al actualizar',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box p={4} borderWidth="1px" borderRadius="lg" overflow="auto" className="admin-page-container">
      <VStack spacing={6} align="stretch">
        <Box display="flex" justifyContent="space-between" alignItems="center" className="admin-page-header">
          <Text fontSize="xl" fontWeight="bold" className="admin-page-title">
            {t('admin_email_titulo')}
          </Text>
        </Box>

        {/* Tabla de endpoints */}
        <Box overflowX="auto" borderWidth="1px" borderRadius="lg" p={4} className="admin-table-container">
          <Table variant="simple" className="admin-table">
            <Thead>
              <Tr>
                <Th cursor="pointer" onClick={() => handleSort('descripcion')}>
                  Descripción del mensaje
                  {sortBy === 'descripcion' && (sortOrder === 'asc' ? ' ⬆️' : ' ⬇️')}
                </Th>
                <Th cursor="pointer" onClick={() => handleSort('endpoint')}>
                  Endpoint
                  {sortBy === 'endpoint' && (sortOrder === 'asc' ? ' ⬆️' : ' ⬇️')}
                </Th>
                <Th cursor="pointer" onClick={() => handleSort('destinatario')}>
                  Destinatario
                  {sortBy === 'destinatario' && (sortOrder === 'asc' ? ' ⬆️' : ' ⬇️')}
                </Th>
                <Th cursor="pointer" onClick={() => handleSort('habilitado')}>
                  Habilitar
                  {sortBy === 'habilitado' && (sortOrder === 'asc' ? ' ⬆️' : ' ⬇️')}
                </Th>
                <Th cursor="pointer" onClick={() => handleSort('subject')}>
                  Subject
                  {sortBy === 'subject' && (sortOrder === 'asc' ? ' ⬆️' : ' ⬇️')}
                </Th>
                <Th>Prueba</Th>
              </Tr>
            </Thead>
            <Tbody>
              {emailEndpoints.map((endpoint, index) => (
                <Tr key={index}>
                  <Td>{endpoint.descripcion}</Td>
                  <Td fontFamily="mono" fontSize="sm">{endpoint.endpoint}</Td>
                  <Td>
                    <Text 
                      fontSize="sm" 
                      fontWeight="bold"
                      color={endpoint.destinatario === 'Administrador' ? 'purple.600' : endpoint.destinatario === 'Cliente' ? 'blue.600' : 'green.600'}
                    >
                      {endpoint.destinatario}
                    </Text>
                  </Td>
                  <Td>
                    <Switch 
                      isChecked={endpoint.habilitado}
                      onChange={() => handleToggle(index)}
                    />
                  </Td>
                  <Td fontSize="sm">{endpoint.subject}</Td>
                  <Td>
                    <HStack spacing={2}>
                      <Menu>
                        <MenuButton
                          as={IconButton}
                          aria-label="Seleccionar idioma"
                          icon={
                            <img
                              src={`/assets/icons/${selectedLanguages[endpoint.endpoint] || 'es'}.png`}
                              alt={selectedLanguages[endpoint.endpoint] || 'es'}
                              style={{
                                height: 18,
                                borderRadius: 4,
                                background: 'transparent',
                              }}
                            />
                          }
                          variant="outline"
                          size="sm"
                          bg="gray.100"
                          _hover={{ bg: 'gray.200' }}
                        />
                        <MenuList
                          minW="40px"
                          w="40px"
                          p={1}
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          bg="gray.100"
                          boxShadow="md"
                        >
                          <MenuItem
                            onClick={() => setSelectedLanguages(prev => ({ ...prev, [endpoint.endpoint]: 'es' }))}
                            p={1}
                            px={0}
                            w="auto"
                            minW="unset"
                            maxW="32px"
                            display="flex"
                            justifyContent="center"
                            bg="gray.100"
                            _hover={{ bg: 'gray.200' }}
                          >
                            <img src="/assets/icons/es.png" alt="es" style={{ height: 18, borderRadius: 4, background: 'white', display: 'block' }} />
                          </MenuItem>
                          <MenuItem
                            onClick={() => setSelectedLanguages(prev => ({ ...prev, [endpoint.endpoint]: 'ca' }))}
                            p={1}
                            px={0}
                            w="auto"
                            minW="unset"
                            maxW="32px"
                            display="flex"
                            justifyContent="center"
                            bg="gray.100"
                            _hover={{ bg: 'gray.200' }}
                          >
                            <img src="/assets/icons/ca.png" alt="ca" style={{ height: 18, borderRadius: 4, background: 'transparent', display: 'block' }} />
                          </MenuItem>
                          <MenuItem
                            onClick={() => setSelectedLanguages(prev => ({ ...prev, [endpoint.endpoint]: 'en' }))}
                            p={1}
                            px={0}
                            w="auto"
                            minW="unset"
                            maxW="32px"
                            display="flex"
                            justifyContent="center"
                            bg="gray.100"
                            _hover={{ bg: 'gray.200' }}
                          >
                            <img src="/assets/icons/en.png" alt="en" style={{ height: 18, borderRadius: 4, background: 'white', display: 'block' }} />
                          </MenuItem>
                          <MenuItem
                            onClick={() => setSelectedLanguages(prev => ({ ...prev, [endpoint.endpoint]: 'de' }))}
                            p={1}
                            px={0}
                            w="auto"
                            minW="unset"
                            maxW="32px"
                            display="flex"
                            justifyContent="center"
                            bg="gray.100"
                            _hover={{ bg: 'gray.200' }}
                          >
                            <img src="/assets/icons/de.png" alt="de" style={{ height: 18, borderRadius: 4, background: 'white', display: 'block' }} />
                          </MenuItem>
                          <MenuItem
                            onClick={() => setSelectedLanguages(prev => ({ ...prev, [endpoint.endpoint]: 'fr' }))}
                            p={1}
                            px={0}
                            w="auto"
                            minW="unset"
                            maxW="32px"
                            display="flex"
                            justifyContent="center"
                            bg="gray.100"
                            _hover={{ bg: 'gray.200' }}
                          >
                            <img src="/assets/icons/fr.png" alt="fr" style={{ height: 18, borderRadius: 4, background: 'white', display: 'block' }} />
                          </MenuItem>
                          <MenuItem
                            onClick={() => setSelectedLanguages(prev => ({ ...prev, [endpoint.endpoint]: 'it' }))}
                            p={1}
                            px={0}
                            w="auto"
                            minW="unset"
                            maxW="32px"
                            display="flex"
                            justifyContent="center"
                            bg="gray.100"
                            _hover={{ bg: 'gray.200' }}
                          >
                            <img src="/assets/icons/it.png" alt="it" style={{ height: 18, borderRadius: 4, background: 'transparent', display: 'block' }} />
                          </MenuItem>
                          <MenuItem
                            onClick={() => setSelectedLanguages(prev => ({ ...prev, [endpoint.endpoint]: 'ru' }))}
                            p={1}
                            px={0}
                            w="auto"
                            minW="unset"
                            maxW="32px"
                            display="flex"
                            justifyContent="center"
                            bg="gray.100"
                            _hover={{ bg: 'gray.200' }}
                          >
                            <img src="/assets/icons/ru.png" alt="ru" style={{ height: 18, borderRadius: 4, background: 'transparent', display: 'block' }} />
                          </MenuItem>
                        </MenuList>
                      </Menu>
                      <Button
                        size="sm"
                        colorScheme="blue"
                        onClick={() => handleTestEmail(endpoint.endpoint)}
                        isLoading={testingEndpoint === endpoint.endpoint}
                        loadingText="Enviando..."
                      >
                        Prueba
                      </Button>
                    </HStack>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>

        {/* Logs */}
        <Box borderWidth="1px" borderRadius="lg" p={4} className="admin-logs-container">
          <HStack justify="space-between" mb={4} className="admin-logs-header">
            <Text fontSize="lg" fontWeight="bold" className="admin-logs-title">
              Logs de Email (logs/pyapp/pyapp_access.log)
            </Text>
            <Button 
              onClick={fetchLogs} 
              isLoading={isLoadingLogs}
              colorScheme="blue"
              size="sm"
              className="admin-button-primary"
            >
              Actualizar
            </Button>
          </HStack>
          <Textarea
            value={logs}
            readOnly
            fontFamily="mono"
            fontSize="sm"
            minH="300px"
            placeholder="Cargando logs..."
            className="admin-logs-textarea"
          />
        </Box>
      </VStack>
    </Box>
  );
};

export default AdminEmail;


